import { render } from "./fieldCustomRadios.vue?vue&type=template&id=6446f7c4"
import script from "./fieldCustomRadios.vue?vue&type=script&lang=js"
export * from "./fieldCustomRadios.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__